import { useEffect, useRef, useState } from "react";
import { useResponsiveMobile } from "../../../hooks/useResponsiveMobile";

/**  PC/모바일 공통: 요소 60% 보이면 아래→위로 등장 */
function useInViewOnce<T extends HTMLElement>(
  options: IntersectionObserverInit = { threshold: 0.6 },
) {
  const ref = useRef<T | null>(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const io = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setInView(true);
        io.disconnect(); //  한 번만 등장
      }
    }, options);

    io.observe(el);
    return () => io.disconnect();
  }, []);

  return { ref, inView };
}

export const Section3 = () => {
  const isMobile = useResponsiveMobile(900);
  //  라벨 / 본문 블록 각각 따로 등장
  const { ref: badgeRef, inView: badgeInView } = useInViewOnce<HTMLSpanElement>({ threshold: 0.6 });

  const { ref: contentRef, inView: contentInView } = useInViewOnce<HTMLDivElement>({
    threshold: 0.6,
  });

  const enterBase = "transition-all duration-700 ease-out will-change-transform";
  const enterHidden = "opacity-0 translate-y-8";
  const enterShown = "opacity-100 translate-y-0";

  return (
    <section className="flex flex-col gap-6 items-center justify-center">
      <span
        ref={badgeRef}
        className={[
          "font-normal text-[#0079FF] text-[20px] md:text-[18px]",
          enterBase,
          badgeInView ? enterShown : enterHidden,
        ].join(" ")}
      >
        Core Value
      </span>

      <div
        ref={contentRef}
        className={[enterBase, contentInView ? enterShown : enterHidden].join(" ")}
      >
        {isMobile ? (
          <div className="flex flex-col gap-10">
            <span className="text-center font-bold text-[36px] text-[#121319]">
              <span className="text-[#0079FF]">분산된 정산 프로세스,</span> <br />
              이젠 품으로 <br /> 한번에 해결하세요
            </span>
            <span className="text-center text-[18px] font-normal text-[#4D4F58]">
              정산을 중심으로 운영의 흐름을 정리하여, <br />
              안정적인 성장을 지원하는 통합 관리 <br />
              서비스입니다.
            </span>
          </div>
        ) : (
          <div className="flex flex-col gap-6">
            <h1 className="font-bold text-display text-center">
              <span className="text-[#0079FF]">분산된 정산 프로세스,</span>
              <br />
              이젠 품으로 한번에 해결하세요
            </h1>
            <span className="text-center text-heading1 font-normal text-[#4D4F58]">
              품은 정산을 중심으로 운영의 흐름을 정리해, 안정적인 성장을 위한 통합 관리
              서비스입니다.
            </span>
          </div>
        )}
      </div>
    </section>
  );
};
